import type { ExerciseItem } from '../../../types/exercise';
import type { TrainingBlock, TrainingBlockExercise } from '../../../types/training';
import { resolveTrainingExerciseMuscleGroups } from './trainingMetrics';

export const applyCatalogExerciseIdentity = (
  item: TrainingBlockExercise,
  nextExercise: ExerciseItem,
): TrainingBlockExercise => ({
  ...item,
  exerciseId: nextExercise.id,
  name: nextExercise.name,
  group: nextExercise.group,
  objective: nextExercise.objective,
  muscleGroups: resolveTrainingExerciseMuscleGroups(nextExercise.group),
});

const mapExerciseTree = (
  items: TrainingBlockExercise[],
  mapper: (item: TrainingBlockExercise) => TrainingBlockExercise,
): TrainingBlockExercise[] => items.map((item) => {
  const mappedItem = mapper(item);

  return {
    ...mappedItem,
    conjugatedExercises: mapExerciseTree(item.conjugatedExercises ?? [], mapper),
  };
});

interface ReplaceExerciseIdentityOptions {
  itemId: string;
  sourceCatalogId: number;
  nextExercise: ExerciseItem;
  replaceInEntirePlan: boolean;
}

export const replaceExerciseIdentityInBlocks = (
  blocks: TrainingBlock[],
  options: ReplaceExerciseIdentityOptions,
): TrainingBlock[] => {
  const shouldReplace = (item: TrainingBlockExercise) => (
    options.replaceInEntirePlan
      ? item.exerciseId === options.sourceCatalogId
      : item.id === options.itemId
  );

  return blocks.map((block) => ({
    ...block,
    items: mapExerciseTree(block.items, (item) => (
      shouldReplace(item) ? applyCatalogExerciseIdentity(item, options.nextExercise) : item
    )),
  }));
};
